import React from "react";
import CertificateLookup from "./components/CertificateLookup";

function App() {
  // This is the main App component that renders the CertificateLookup component.
  return (
    <div>
      <CertificateLookup />
    </div>
  );
}

export default App;
